import { FaTshirt, FaHandHoldingUsd } from "react-icons/fa";

const mission = {
  sub: "Our Mission",
  heading: "Empowering Clients, Building Care Experts.",
  content:
    "At Laundry Care, our mission is to empower our clients, providing them with the support and resources needed to become care experts for their garments.",
  points: [
    {
      id: 1,
      icon: <FaTshirt />, // T-shirt icon
      title: "Premium Care",
      content: "We strive for premium care in every service, fostering a culture of garment care excellence and quality assurance.",
    },
    {
      id: 2,
      icon: <FaHandHoldingUsd />, // Hand holding money icon
      title: "Affordability",
      content: "We promote affordable laundry and dry cleaning services, making care accessible to everyone in the community.",
    },
    {
      id: 3,
      icon: <FaTshirt />, // Reuse T-shirt icon or can use another icon
      title: "Client Empowerment",
      content: "We empower our clients with knowledge and resources, helping them to become experts in garment care.",
    },
  ],
};

export default mission;